import { useEffect, useState } from "react";

const BSModal = ({
	modal_display_bool = false,
	setModalDisplay,
	modal_html = ""
}) => {
	const [modal_style, setModalStyle] = useState({ display: "none" });
	useEffect(() => {
		if (modal_display_bool) {
			setModalStyle({ display: "block" });
		}
	}, [modal_display_bool]);
	const handleModalHide = (event) => {
		setModalStyle({ display: "none" });
		setModalDisplay(false);
	};
	const modal_jsx = (
		<div
			style={modal_style}
			className="modal show"
			id={
				"modal_" +
				(Date.now() * Math.random() * Math.random())
					.toString()
					.replace(/\./g, "")
			}
			tabIndex={-1}
		>
			<div className="modal-dialog shadow-lg">
				<div className="modal-content">
					<div
						style={{
							padding: 0,
							display: "flex",
							justifyContent: "flex-end",
							width: "98%"
						}}
					>
						<button
							style={{
								padding: 2,
								backgroundColor: "white"
							}}
							onClick={handleModalHide}
							type="button"
							className="btn btn-light"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							&times;
						</button>
					</div>
					<div
						className="modal-body"
						dangerouslySetInnerHTML={{ __html: modal_html }}
					/>
				</div>
			</div>
		</div>
	);
	return modal_jsx;
};

export default BSModal;
